export const ALLOWED_PLACEMENTS = <const>[
  'top',
  'top-start',
  'top-end',
  'bottom',
  'bottom-start',
  'bottom-end',
];

export const POPOVER_WIDTH = '320px';

export const POPOVER_OFFSET = <[number, number]>[0, 16];
